import { http } from "./http";
import type { SignupNotice } from "../types/auth";

// App-tips emails. Public: nothing is stored, nobody needs to be signed in.
export const tipsApi = {
  /** Which app-tips box the sign-in screen shows, by the phone's timezone (server lib/talentTips/consent.js). */
  signupNotice: (tz: string) => http.get<SignupNotice>("/tips/signup-notice", { params: { tz } }),
};
